import { render, staticRenderFns } from "./CustomFieldFormat.vue?vue&type=template&id=2e5c4f3c&lang=pug"
import script from "./CustomFieldFormat.vue?vue&type=script&lang=js"
export * from "./CustomFieldFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports